"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcommunity = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 55",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcommunity` : '') + (description ? ` desc-brandedcommunity` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcommunity"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcommunity"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.57 2.64A9 9 0 1 1 34.3 15.36 9 9 0 0 1 21.57 2.64Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28 8.77a6.96 6.96 0 0 1 11.9 4.95 7.01 7.01 0 0 1-6.97 7 6.96 6.96 0 0 1-6.97-7 7 7 0 0 1 2.04-4.95Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.82 8.77a6.96 6.96 0 0 1 11.9 4.95 7.01 7.01 0 0 1-6.97 7 6.96 6.96 0 0 1-6.97-7 7 7 0 0 1 2.04-4.95Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.26 23.97a10.9 10.9 0 0 0-6.83-2.37 10.9 10.9 0 0 0-7.37 2.83A9.37 9.37 0 0 0 0 31.3v10.46a6.9 6.9 0 0 0 3.32 5.82c3.2 2 7.14 2.52 10.71 1.53a11.4 11.4 0 0 1-.24-2.34V34.7a15.06 15.06 0 0 1 3.47-10.74Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.18 26.35c.67 1.48.75 3.19.75 4.95v13.02c0 .65-.58 2.38-1.16 2.74l-1.23.52c-.22.14-.35.27-.57.4-.06-.4-.19-.8-.19-1.21V34.59a12.05 12.05 0 0 1 2.4-8.24Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.96 48.77c3.57.91 7.48.38 10.67-1.6a6.88 6.88 0 0 0 3.37-5.8V30.9a9.3 9.3 0 0 0-3.1-6.87 11.1 11.1 0 0 0-7.48-2.83c-2.48 0-4.88.8-6.78 2.25a14.67 14.67 0 0 1 2.85 5l-2.84.95a11.7 11.7 0 0 0-1.93-3.58c-.59 1.48-.57 3.25-.56 4.9v12.13c0 .33-.02.65-.05.96-.08 1.1-.15 2 .93 2.66l1.16.72c.3.18.6.35.92.51.06-.43.1-.87.1-1.32V34.19a12.1 12.1 0 0 0-.57-4.79l2.84-.94c.62 1.87.87 3.86.72 5.85v12.06c0 .8-.09 1.61-.25 2.4Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 22.34a10.84 10.84 0 0 1 12.54 2.71 11.65 11.65 0 0 1 2.41 4.15c.5 1.53.7 3.16.57 4.79v12.18c0 2.55-1.13 4.9-2.95 6.18a13.92 13.92 0 0 1-16.34 0c-1.82-1.27-2.95-3.63-2.95-6.18V33.99a12.1 12.1 0 0 1 .57-4.79 11.65 11.65 0 0 1 2.4-4.15 11.14 11.14 0 0 1 3.74-2.71Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.9 18h.2a8.95 8.95 0 0 0 8.97-9 9.02 9.02 0 0 0-9.17-9v18Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9 55a14.2 14.2 0 0 0 8.37-2.65c1.82-1.27 2.95-3.63 2.95-6.18V33.99a12.1 12.1 0 0 0-.57-4.79 11.65 11.65 0 0 0-2.4-4.15 10.84 10.84 0 0 0-8.34-3.65V55Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedcommunity;